export const footerLinks = [
  {
    key: 'legalNotice',
    href: 'https://germen.io/mentions-legales/',
  },
  {
    key: 'privacyPolicy',
    href: 'https://germen.io/politique-de-confidentialite/',
  },
] as const;
